import { Card, Group, Text, Stack, SimpleGrid, Box, Menu, ActionIcon } from '@mantine/core'
import {
  IconDotsVertical,
  IconClock,
  IconCancel,
  IconUser,
  IconClockEdit,
} from '@tabler/icons-react'
import { formatDateTime } from '@/utils.ts'
interface InfoTileProps {
  icon: React.ReactNode
  label: string
  value: string | number | undefined
}

const InfoTile = ({ icon, label, value }: InfoTileProps) => {
  return (
    <Card
      radius="lg"
      p="md"
      withBorder
      style={{
        background: 'rgba(255,255,255,0.6)',
        borderColor: 'rgba(0,0,0,0.06)',
      }}
    >
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Group gap="sm" wrap="nowrap" style={{ minWidth: 0 }}>
          <Box
            style={{
              width: 30,
              height: 30,
              borderRadius: 12,
              display: 'grid',
              placeItems: 'center',
              background: 'rgba(34, 139, 230, 0.10)',
              border: '1px solid rgba(34, 139, 230, 0.18)',
              flex: '0 0 auto',
            }}
          >
            {icon}
          </Box>

          <Stack gap={2} style={{ minWidth: 0 }}>
            <Text size="xs" c="dimmed" style={{ textAlign: 'left' }}>
              {label}
            </Text>

            <Text fw={650} size="sm" style={{ wordBreak: 'break-word' }}>
              {value}{' '}
            </Text>
          </Stack>
        </Group>
      </Group>
    </Card>
  )
}

type AppointmentCardProps = {
  start: string
  doctorName?: string
  appointmentId: string
  handleAppointmentCancelation: (id: string) => void
  setSelectedSlotToEdit: () => void
}

export function AppointmentCard({
  start,
  doctorName,
  appointmentId,
  handleAppointmentCancelation,
  setSelectedSlotToEdit,
}: AppointmentCardProps) {
  const startTime = new Date(start).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
  return (
    <Card
      radius="xl"
      p="sm"
      withBorder
      className="flex !p-4"
      style={{
        width: 250,
        margin: '0 10',
        borderColor: 'rgba(34, 139, 230, 0.18)',
        background:
          'radial-gradient(1200px 600px at 20% -10%, rgba(34,139,230,0.14) 0%, transparent 55%),' +
          'radial-gradient(900px 500px at 110% 10%, rgba(99,102,241,0.10) 0%, transparent 55%),' +
          'linear-gradient(180deg, rgba(255,255,255,0.92) 0%, rgba(255,255,255,0.98) 100%)',
        boxShadow: '0 20px 45px rgba(0,0,0,0.08), 0 2px 10px rgba(0,0,0,0.05)',
      }}
    >
      <SimpleGrid spacing="sm">
        <div className="flex items-center justify-center">
          <Text className="w-full text-center"> {start ? formatDateTime(start) : ''}</Text>
          <Menu>
            <Menu.Target>
              <ActionIcon variant="transparent">
                <IconDotsVertical size={18} />
              </ActionIcon>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item
                leftSection={<IconCancel size={14} />}
                onClick={() => handleAppointmentCancelation(appointmentId)}
              >
                Cancel
              </Menu.Item>
              <Menu.Item
                leftSection={<IconClockEdit size={14} />}
                onClick={() => setSelectedSlotToEdit()}
              >
                Reschedule
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
        <InfoTile icon={<IconClock size={22} />} label="Time" value={startTime} />
        <InfoTile icon={<IconUser size={22} />} label="Provider" value={doctorName} />
      </SimpleGrid>
      <div></div>
    </Card>
  )
}
